export default __webpack_public_path__ + "static/media/view.5e7754fc.svg";